import _jsx from "@babel/runtime/helpers/jsx";
var _Glyphicon;
import React from 'react';
import PropTypes from 'prop-types';
import { Glyphicon } from 'reaxl';
export function Avatar(_ref) {
  let {
    profile
  } = _ref;
  const {
    thumbnailUrl,
    firstName,
    lastName
  } = profile;
  let content;
  if (thumbnailUrl) {
    content = /*#__PURE__*/_jsx("img", {
      className: "header-avatar-image",
      src: thumbnailUrl,
      alt: "",
      "aria-hidden": "true"
    });
  } else if (firstName) {
    const initials = `${firstName.charAt(0)}${lastName ? lastName.charAt(0) : ''}`;
    content = /*#__PURE__*/_jsx("span", {
      "aria-hidden": "true"
    }, void 0, initials.toUpperCase());
  } else {
    content = _Glyphicon || (_Glyphicon = /*#__PURE__*/_jsx(Glyphicon, {
      glyph: "user-circle-solid"
    }));
  }
  return /*#__PURE__*/_jsx("div", {
    className: "header-avatar"
  }, void 0, content);
}
function ProfileContainer(_ref2) {
  let {
    profile
  } = _ref2;
  return /*#__PURE__*/_jsx("div", {
    className: "header-profile-container"
  }, void 0, /*#__PURE__*/_jsx(Avatar, {
    profile: profile
  }), /*#__PURE__*/_jsx("div", {
    className: "header-profile-name"
  }, void 0, "Hello", profile.firstName ? `, ${profile.firstName}!` : '!'));
}
export default ProfileContainer;